import script from "./HrDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDataTable.vue?vue&type=script&setup=true&lang=js"

import "./HrDataTable.vue?vue&type=style&index=0&id=18c3ab6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c3ab6e"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QCheckbox});
